module.exports = ".row .detail-row {\n  padding-left: 30px;\n  padding-right: 30px; }\n\n.tablediv {\n  padding-right: 5px;\n  padding-left: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/generate-report/isbn-changed-report-table/isbn-changed-report-table.component.scss
// module id = ./src/app/+app-custom/components/generate-report/isbn-changed-report-table/isbn-changed-report-table.component.scss
// module chunks = main